/**
 * Метод проверяет, работает ли текущий сессия ЛК из мобильного приложения.
 * Если да, то возвращает платформу
 */
export const getUserMobileAgent = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return null;
};
